// extracted by mini-css-extract-plugin
export default {"map":"maps-chart__map___6Moig","popUpAttributeTitle":"maps-chart__popUpAttributeTitle___C1vV_"};